import EventEmitter from "eventemitter3";
export const eventEmitter = new EventEmitter();
export const EVENT_API_FAILURE = "event:api_failure";
export const EVENT_WS_MESSAGE = "event:ws_message";
//# sourceMappingURL=events.js.map